import { responsiveContainer } from "@huub-web/ui/utils/responsive";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

const BREAKPOINT = 980;

export const filterGridStyle = style({
  display: "grid",
  gridTemplateColumns: "repeat(5, 1fr)",
  gap: theme.spacings.s,
  ...responsiveContainer({
    [BREAKPOINT]: {
      gridTemplateColumns: "repeat(9, 1fr)",
    },
  }),
});

export const filterGridFirstColumnStyle = style({
  gridColumn: "span 3",
  gridRow: 1,
  ...responsiveContainer({
    [BREAKPOINT]: {
      gridColumn: "span 3",
      gridRow: 1,
    },
  }),
});

export const filterGridSecondColumnStyle = style({
  gridColumn: "span 5",
  gridRow: 2,
  ...responsiveContainer({
    [BREAKPOINT]: {
      gridColumn: "span 4",
      gridRow: 1,
    },
  }),
});

export const filterGridThirdColumnStyle = style({
  height: "100%",
  gridColumn: "span 2",
  gridRow: 1,
  ...responsiveContainer({
    [BREAKPOINT]: {
      gridColumn: "span 2",
      gridRow: 1,
    },
  }),
});

export const ctaSmallStyle = style({
  display: "block",
  ...responsiveContainer({
    [BREAKPOINT]: {
      display: "none",
    },
  }),
});

export const ctaStyle = style({
  display: "none",
  ...responsiveContainer({
    [BREAKPOINT]: {
      display: "block",
    },
  }),
});
export const filterOptionsContainerStyle = style({
  position: "sticky",
  top: `calc(${rem(64)} + ${theme.spacings.xs})`,
  zIndex: 3,
});

export const subGridStyle = style({
  display: "grid",
  gridTemplateColumns: "repeat(5, 1fr)",
  gap: theme.spacings.xxs,
});

export const debtMarketValueOptionsContainerStyle = style({
  paddingLeft: theme.spacings.xxs2,
  paddingRight: theme.spacings.xxs,
});

export const energyLabelSelectStyle = style({
  alignSelf: "flex-end",
  width: "auto",
});

export const energyLabelStyle = style({
  alignSelf: "flex-start",
});

export const rentevastePeriodSelectStyle = style({
  alignSelf: "flex-start",
  width: "auto",
});

export const interestRateRowImageStyle = style({
  width: rem(80),
  height: rem(40),
  objectFit: "contain",
  objectPosition: "left center",
  filter: "grayscale(100%)",
  userSelect: "none",
});

export const listStyle = style({
  borderRadius: theme.borderRadiuses.s,
  border: `1px solid ${theme.colors.defaultBorder}`,
});

export const listRowStyle = style({
  padding: theme.spacings.s,
  selectors: {
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.colors.defaultBorder}`,
    },
  },
});

export const valueParserStyle = recipe({
  base: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  variants: {
    active: {
      true: {
        color: theme.colors.primary,
        fontWeight: "bold",
      },
    },
  },
});

export const textStyle = style({
  maxWidth: rem(660),
  margin: "0 auto",
});
